import { render, staticRenderFns } from "./TopProductsList.vue?vue&type=template&id=1983af10&scoped=true&"
import script from "./TopProductsList.vue?vue&type=script&lang=js&"
export * from "./TopProductsList.vue?vue&type=script&lang=js&"
import style0 from "./TopProductsList.vue?vue&type=style&index=0&id=1983af10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1983af10",
  null
  
)

export default component.exports